import Reject from './Reject.container';

export default Reject;
